<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 退款记录 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 180px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select
            v-model="formInline.paymentType"
            @change="queryClick"
            style="width: 140px"
            placeholder="支付方式"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="微信" value="wepay"></el-option>
            <el-option label="支付宝" value="alipay"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            style="width: 240px"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div style="padding: 10px">
        <time-range @change="handleTimeChange" />
        <div v-if="storeGuid && times">
          <x-table
            ref="list"
            listApi="biz.warehouse.payment.refund.list"
            paginationLayout="total, sizes, prev, next, jumper"
            actionFixed="right"
            emptyLabel="暂无退款记录信息"
            :fieldList="fieldList"
            :actionList="actionList"
            :defaultParams="defaultParams"
            :actionWidth="160"
          >
            <template slot="row-info" slot-scope="scope">
              <warehouse-payment-refund :refundInfo="scope.row" />
            </template>
          </x-table>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import timeRange from '../../../../components/timeRange.vue';
import warehousePaymentRefund from '../../../../components/business/warehousePaymentRefund.vue';
import customerStoreSelect from '../../../../components/business/customerStoreSelect.vue';

export default {
  components: {
    timeRange,
    warehousePaymentRefund,
    customerStoreSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
    }
  },
  computed: {
    defaultParams() {
      return Object.assign({
        storeGuid: this.storeGuid,
      }, this.queryModel || {}, this.times);
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  methods: {
    clearClick() {
      this.formInline = {
        paymentType: "",
        queryValue: ""
      }
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({
      }, this.formInline);
    },
    handleTimeChange(time) {
      this.times = time;
    },
  },
  data() {
    return {
      times: null,
      storeGuid: "",
      queryModel: {},
      formInline: {
        paymentType: "",
        queryValue: ''
      },
      fieldList: [
        {
          label: "退款信息",
          minWidth: '280',
          slot: "info",
        },
      ],
      actionList: [
      ],
    };
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
  }
};
</script>